import bolitas from "../bolitas";
var testimonios = function () {
    bolitas(document.querySelector('.testimonios__lista'), '.testimonios__testimonio');
    Array.from(document.querySelectorAll('.testimonios__lista:has(video)')).forEach(function (el) {
        el.addEventListener('scroll', function () {
            videos.forEach(function (video) { return video.pause(); });
        });
        var videos = Array.from(document.querySelectorAll('video'));
        videos.forEach(function (video) {
            video.addEventListener('play', function () {
                video.classList.add('active');
            });
            video.addEventListener('pause', function () { return video.classList.remove('active'); });
        });
    });
};
export default testimonios;
